/**
 * 学习乐园 · 连连看题材包：事件配朝代（lianliankan/pack-shijian.js）
 * ---------------------------------------------------------------------------
 * 关联型配对：历史事件连朝代（「造纸术改良」连「东汉」）。note 存一句
 * 说明——配上就听见「蔡伦改进造纸术」，事件、朝代、人物三者挂钩。
 * 口径自检：22 条覆盖从上古到近代的历史线，朝代/文明面只收一条——
 * 同一朝代出现两次会造成两张同名牌分属不同对，配错反馈没法指对
 * 搭档（rel 型按 pair 报 mate，同 face 两张牌玩家无法区分）。
 * 22 对池（6×6 盘每局随机抽 18 上桌），多玩几局凑齐整条历史线。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  PACKS.shijian = {
    id: 'shijian',
    name: '事件配朝代',
    hint: '造纸术连东汉，一条事件线',
    kind: 'rel',
    cols: 6,
    rows: 6,
    pairs: [
      { l: '涿鹿之战', r: '上古传说', note: '炎黄部落联合战蚩尤' },
      { l: '大禹治水', r: '夏朝', note: '三过家门而不入' },
      { l: '甲骨文', r: '商朝', note: '刻在龟甲兽骨上的文字' },
      { l: '牧野之战', r: '西周', note: '武王伐纣的决战' },
      { l: '百家争鸣', r: '东周', note: '孔孟老庄，思想最热闹的五百年' },
      { l: '商鞅变法', r: '战国', note: '使秦国一步步强大' },
      { l: '丝绸之路', r: '西汉', note: '张骞通西域后开通' },
      { l: '造纸术改良', r: '东汉', note: '蔡伦改进造纸术' },
      { l: '三顾茅庐', r: '三国', note: '刘备三次请诸葛亮' },
      { l: '淝水之战', r: '东晋', note: '八万破八十万，风声鹤唳' },
      { l: '贞观之治', r: '唐朝', note: '唐太宗年间的治世' },
      { l: '澶渊之盟', r: '北宋', note: '宋辽议和，换得和平' },
      { l: '郾城大捷', r: '南宋', note: '岳飞大破金军' },
      { l: '马可·波罗来华', r: '元朝', note: '元世祖时来中国' },
      { l: '郑和下西洋', r: '明朝', note: '七下西洋，远达非洲' },
      { l: '虎门销烟', r: '清朝', note: '林则徐销毁鸦片' },
      { l: '五四运动', r: '民国', note: '1919 年，唤醒救亡的年代' },
      { l: '科举制创立', r: '隋朝', note: '隋炀帝设进士科' },
      { l: '秦统一六国', r: '秦朝', note: '第一个统一王朝' },
      { l: '金字塔', r: '古埃及', note: '法老的陵墓' },
      { l: '汉谟拉比法典', r: '古巴比伦', note: '最早的成文法典之一' },
      { l: '奥运会起源', r: '古希腊', note: '公元前 776 年起，四年一届' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
